export default __webpack_public_path__ + "static/media/waveaudio.58d0f33f.png";